<template>
  <div class="curriculumEdit">
    <!-- <div class="message" v-if="!realName">
        <el-alert title="" type="warning" show-icon :closable="false">请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。</el-alert>
    </div> -->
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
            <div class="module padding-20 bgc box-shadow">
                <div class="classes blod module_title">
                    <p class="title">基本信息</p>
                </div>
                <el-form-item label="课程类型" prop="coursetype" required>
                    <el-radio-group v-model="item.coursetype" :disabled="disabled">
                        <el-radio :label="1">单课</el-radio>
                        <el-radio :label="2">系列课</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否公开" prop="ispublic" required>
                    <el-radio-group v-model="item.ispublic">
                        <el-radio :label="1">公开</el-radio>
                        <el-radio :label="0">不公开</el-radio>
                    </el-radio-group>
                    <el-popover placement="right" trigger="hover" content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                        <div class="tipsP">
                            <p>公开：平台内的搜索、推荐都可以查询到该课程。</p>
                            <p>不公开：平台内的搜索、推荐不可以查询到该课程，只能使用课程详情分享才能查看</p>
                        </div>
                        <i class="el-icon-info" slot="reference"></i>
                    </el-popover>
                </el-form-item>

                <el-form-item label="课程名称" prop="subject" class="videoName">
                    <el-input v-model.trim="item.subject" placeholder="请输入课程名称(建议字数不超过35个字)" maxlength="35" show-word-limit clearable></el-input>
                </el-form-item>
                <el-form-item label="课程简介">
                    <el-input v-model="item.description" type="textarea" placeholder="请输入课程简介(不超过90个字)" maxlength="90" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="课程内容" v-if="item.coursetype == 1" required>
                    <p class="color-999">选择已有内容：来源于内容运营部分，包括视频、音频、电子书/报告</p>
                    <p class="color-999">上传本地视频：只能选择本地视频上传，格式为mp4</p>
                    <p class="color-999">上传本地音频：只能选择本地音频上传，格式为mp3</p>
                    <template v-if="item.courseinfo.length > 0">
                        <div class="fledx curriculum-item"  v-for="(items, index) in item.courseinfo" :key="index">
                            <img :src="item.fileuploadtype === 1 ? items.furl : videoPng" :alt="items.objectname">
                            <p>{{items.objectname}}</p>
                            <p @click="item.courseinfo = ''">删除</p>
                        </div>
                    </template>
                    <div class="uploadBtnBox">
                        <el-button class="had" @click="openShopDialog">选择已有内容</el-button>
                        <uploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                        <div style="margin-left: 20px;">
                            <uploadFile :uploadType="uploadVideoType2" @setFile="setFile2" :fileRule="fileRule2"></uploadFile>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="课程封面" prop="coverpicture" class="upload-image" required>
                    <upload class="headImage" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                    <div class="el-upload__tip">
                        <el-button type="warning" @click="openCoverScrollBox">素材库</el-button>
                        <div>课程封面是指在商品列表展示的图片。建议尺寸750*420px，JPG、PNG格式， 图片小于5M。 </div>
                    </div>
                </el-form-item>
                <!--课程分类-->
                <el-form-item label="课程分类" class="addLang">
                    <el-cascader v-if="!user.isvcahost" v-model="item.code" :options="caseList" :props="{ expandTrigger: 'hover',value:'code',label:'name',children:'codelist' }"></el-cascader>
                    <el-select v-else v-model="item.code">
                        <el-option v-for="(item, index) in vcaCoursetype" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="自定义分类" class="addLang" v-if="user.isofficalhost">
                    <el-cascader v-model="customcatecode" :options="dmCaseList" @change="handleCustomcateChange"></el-cascader>
                </el-form-item>
                <el-form-item label="支持董秘会员" v-if="user.isofficalhost">
                    <el-radio-group v-model="item.bigmemtype">
                        <el-radio :label="1">支持</el-radio>
                        <el-radio :label="0">不支持</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="资鲸会员类型" v-if="user.iszjhost" class="addLang">
                    <el-select v-model="item.zjmemtype">
                        <el-option :label="item.label" :value="item.value" v-for="(item, index) in zjmemtype" :key="index"></el-option>
                    </el-select>
                    <!-- <el-radio-group v-model="item.zjmemtype">
                        <el-radio :label="1">支持</el-radio>
                        <el-radio :label="0">不支持</el-radio>
                    </el-radio-group> -->
                </el-form-item>
                <!--课程老师-->
                <el-form-item label="课程老师"  class="addLang">
                    <el-select class="multipleSelect" v-model="teacherinfo" multiple placeholder="请选择课程关联的老师 ">
                        <el-option v-for="item in teachList" :key="item.teacherid" :label="item.orgname" :value="item.teacherid"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="开课开始时间" v-show="item.coursetype == 2" required>
                    <el-date-picker
                        v-model="item.begintime"
                        type="datetime"
                        placeholder="请选择开课时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        style="width:440px; margin-left: 0;}"
                        >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="课程详情">
                    <uEditor :content="item.content" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
                </el-form-item>
                <!-- <el-form-item label="商品分组" class="commodityGroup" v-if="domain === 1"> -->
                <el-form-item label="商品分组" class="commodityGroup">
                    <el-select class="multipleSelect" v-model="item.divisionids" multiple placeholder="请选择" clearable>
                        <el-option v-for="item in shopGroupList" :key="item.innerid" :label="item.name" :value="item.innerid"> </el-option>
                    </el-select>
                    <el-button type="text" size="small" @click="_getShopGroupList">刷新</el-button>
                    <el-button type="text" size="small" @click="goGoodsGroup">前往商品分组</el-button>
                    <p class="groupTips">商品分组可辅助你更好地管理商品</p>
                </el-form-item>
                <el-form-item label="关联题库">
                    <div class="relevancyqb">
                        <div class="btnTips">
                            <el-button icon="el-icon-plus" @click="handleChoiceQb">选择题库</el-button>
                            <div class="tips">课程绑定题库后，可免费参与考试</div>
                        </div>
                        <div class="quesItem" v-for="(item, index) in quesList" :key="index">
                            <div class="name">{{ item.kmcname }}</div>
                            <div class="delete" @click="handleDeleteQues(index)">删除</div>
                        </div>
                    </div> 
                </el-form-item>
            </div>
            <div class="module padding-20 bgc box-shadow">
                <div class="classes blod module_title">
                    <p class="title">课程配置</p>
                </div>

                <el-form-item label="课程价格">
                    <curriculumMsg ref="curriculumMsg" @changeWay="changeWay" :zjmemtype="item.zjmemtype"></curriculumMsg>
                </el-form-item>

                <el-form-item label="目录解锁模式" v-show="item.coursetype == 2" required>
                    <el-radio-group v-model="item.sectionunlocktype" class="model-ml">
                        <el-radio :label="1" style="margin-bottom: 10px">自由模式
                            <p>开课后学员可以学习任意一节课</p>
                        </el-radio>
                        <el-radio :label="2">日期解锁
                            <p>开课后每N天/周解锁一节课或者任务，学员只可以学习已解锁的课程</p>
                        </el-radio>
                    </el-radio-group>

                    <div class="fledx setup" v-if="item.sectionunlocktype == 2">
                        <p>每</p>
                        <el-input v-model="dateunlockconfig.day"></el-input>
                        <el-select v-model="dateunlockconfig.date">
                            <el-option label="天" :value="1" :key="1"></el-option>
                            <el-option label="周" :value="2" :key="2"></el-option>
                        </el-select>
                        <p>解锁一</p>
                        <el-select v-model="dateunlockconfig.task">
                            <el-option label="章节" :value="1" :key="1"></el-option>
                            <el-option label="任务" :value="2" :key="2"></el-option>
                        </el-select>
                    </div>
                    <div class="fledx" v-if="item.sectionunlocktype == 2">
                        <p>解锁时间</p>
                        <el-time-picker
                        v-model="item.dateunlocktime"
                        :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59'
                        }"
                        value-format='HH:mm'
                        format="HH:mm"
                        placeholder="选择解锁时间"
                        style="width:224px;">
                    </el-time-picker>
                    </div>
                    <!-- 日期解锁情况下出现 -->

                </el-form-item>

                <el-form-item label="购买有效期" required>
                    <el-radio-group v-model="item.isbuyexpire">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                    <p class="color-999">付费课程购买后在一定期限内可用</p>
                    <div class="fledx courseFlex" v-if="item.isbuyexpire == 1">
                        <p>有效期限</p><el-input v-model="item.expiredays" placeholder="请输入整数"></el-input><p>天</p>
                    </div>
                </el-form-item>

                <el-form-item label="倍速播放/快进" required>
                    <el-radio-group v-model="item.isspeedplay">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                    <p class="color-999">开启状态用户可以倍数播放与自由拖动进度条（iOS和PC端支持选择倍数播放，Android端暂不支持倍数播放）</p>
                    <p class="color-999">关闭状态课程未学完时，禁止倍数播放与拖动进度条。</p>
                </el-form-item>

                <el-form-item label="开课提醒设置" required>
                    <el-radio-group v-model="item.isopennotify">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="2">关闭</el-radio>
                    </el-radio-group>
                    <p class="color-999">目前通知范围包含：报名成功提醒、审核成功提醒、签到通知</p>
                </el-form-item>

                <el-form-item label="开课短信通知" required>
                    <el-radio-group v-model="item.isopensmsnotify">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="2">关闭</el-radio>
                    </el-radio-group>
                    <p class="color-999">开启后，将通过短信发送以上通知类型。短信数量为0时用户将无法收到短信。</p>
                </el-form-item>
            </div>
            <div class="module padding-20 bgc box-shadow">
                <div class="classes blod module_title">
                    <p class="title">防录屏跑马灯</p>
                </div>
                <el-form-item label="防录屏跑马灯" required>
                    <el-radio-group v-model="item.ispreventrecording">
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                    <p class="color-999">开启后，将显示防录屏跑马灯，您可以根据需要去设置参数</p>
                    <p class="color-999">全屏播放时，会导致跑马灯失效。</p>
                </el-form-item>
            </div>
            <div class="module padding-20 bgc box-shadow">
                <div class="classes blod module_title">
                    <p class="title">上架设置</p>
                </div>
                <el-form-item label="上架方式" prop="onlinetype" label-width="120px" class="onLineSet">
                    <shalfSetting :item="item"></shalfSetting>
                </el-form-item>
            </div>
            <div class="courseFrom padding-20 bgc box-shadow module">
                <div class="module_title">
                    <p class="title">购买表单</p>
                    <el-switch v-model="showCourseForm"></el-switch></div>
                <div class="contentBox" v-show="showCourseForm">
                    <el-form-item label="表单类型" class="optionsBox">
                        <div class="flex">
                            <div class="formOptions">
                                <div @click="addInput">
                                    <img src="../../../common/images/nationalDistributionMenu/input.png" alt="">
                                    <div class="name">填写项</div>
                                </div>
                                <div @click="addRandio">
                                    <img src="../../../common/images/nationalDistributionMenu/randio.png" alt="">
                                    <div class="name">单选项</div>
                                </div>
                                <div @click="addCheckbox">
                                    <img src="../../../common/images/nationalDistributionMenu/checkbox.png" alt="">
                                    <div class="name">多选项</div>
                                </div>
                                <div @click="addSelect">
                                    <img src="../../../common/images/nationalDistributionMenu/select.png" alt="">
                                    <div class="name">菜单项</div>
                                </div>
                            </div>
                            <div class="tips">点击相应表单类型即可新增</div>
                        </div>

                    </el-form-item>
                    <SlickList lockAxis="y" v-model="item.customformdataList" class="ques-slickList" :distance="5" :lockToContainerEdges="true">
                        <SlickItem v-for="(item, index) in item.customformdataList" :key="index" :index="index" helper-class="listSelect"  class="slickItem">
                            <el-form-item label="表单项目" class="formItem" >
                                <div>
                                    <div class="input" v-show="item.coltype === 1">
                                        <div class="optionsName">{{index+1}}、填写项 <input type="text" v-model="item.colname" placeholder="请输入填写项内容"></div>
                                        <div class="choiceBox">
                                            <el-radio-group v-model="item.isnotnull">
                                                <el-radio :label="1">必填</el-radio>
                                                <el-radio :label="0">选填</el-radio>
                                            </el-radio-group>
                                        </div>
                                        <img @click="deleteOptions(index)" src="../../../common/images/nationalDistributionMenu/delete_form_item.png" alt="">
                                    </div>
                                    <div class="randio" v-show="item.coltype === 6">
                                        <div class="optionsName">{{index+1}}、单选项 <input type="text" v-model="item.colname" placeholder="请输入单选项内容"></div>
                                        <div class="choiceItem" v-for="(obj, i) in item.optionsArray" :key="i">
                                            <input type="text" placeholder="选项" v-model="obj.optionsName">
                                            <div class="delete"  @click="deleteOptionsName(index)" v-show="i === item.optionsArray.length-1">移除</div>
                                        </div>
                                        <div class="newOptions" @click="addOptions(index)">+新选项</div>
                                        <div class="choiceBox">
                                            <el-radio-group v-model="item.isnotnull">
                                                <el-radio :label="1">必填</el-radio>
                                                <el-radio :label="0">选填</el-radio>
                                            </el-radio-group>
                                        </div>
                                        <img @click="deleteOptions(index)" src="../../../common/images/nationalDistributionMenu/delete_form_item.png" alt="">
                                    </div>
                                    <div class="checkbox" v-show="item.coltype === 7">
                                        <div class="optionsName">{{index+1}}、多选项 <input type="text" v-model="item.colname" placeholder="请输入多选项内容"></div>
                                        <div class="choiceItem" v-for="(obj, i) in item.optionsArray" :key="i">
                                            <input type="text" placeholder="选项" v-model="obj.optionsName">
                                            <div class="delete"  @click="deleteOptionsName(index)" v-show="i === item.optionsArray.length-1">移除</div>
                                        </div>
                                        <div class="newOptions" @click="addOptions(index)">+新选项</div>
                                        <div class="choiceBox">
                                            <el-radio-group v-model="item.isnotnull">
                                                <el-radio :label="1">必填</el-radio>
                                                <el-radio :label="0">选填</el-radio>
                                            </el-radio-group>
                                        </div>
                                        <img @click="deleteOptions(index)" src="../../../common/images/nationalDistributionMenu/delete_form_item.png" alt="">
                                    </div>
                                    <div class="select" v-show="item.coltype === 8">
                                        <div class="optionsName">{{index+1}}、菜单项 <input type="text" v-model="item.colname" placeholder="请输入菜单项内容"></div>
                                        <div class="choiceItem"  v-for="(obj, i) in item.optionsArray" :key="i">
                                            <input type="text" placeholder="选项" v-model="obj.optionsName">
                                            <div class="delete" @click="deleteOptionsName(index)" v-show="i === item.optionsArray.length-1">移除</div>
                                        </div>
                                        <div class="newOptions" @click="addOptions(index)">+新选项</div>
                                        <div class="choiceBox">
                                            <el-radio-group v-model="item.isnotnull">
                                                <el-radio :label="1">必填</el-radio>
                                                <el-radio :label="0">选填</el-radio>
                                            </el-radio-group>
                                        </div>
                                        <img @click="deleteOptions(index)" src="../../../common/images/nationalDistributionMenu/delete_form_item.png" alt="">
                                    </div>
                                </div>
                            </el-form-item>
                        </SlickItem>
                    </SlickList>
                    
                </div>
            </div>
            <div class="btn_box padding-20 bgc">
                <!-- <el-form-item> -->
                    <el-button type="" @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm">提交</el-button>
                <!-- </el-form-item> -->
            </div>
        </el-form>
    </div>
    <scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="setMaterialCoverfile"></scrollBox>
    <shop ref="shop" @setShop="setShopList"></shop>
    <goodsListDialog ref="goodsListDialog" @setCourseQuesList="handleGetQues"></goodsListDialog>
  </div>
</template>

<script>
import {SlickList, SlickItem} from 'vue-slicksort'
import fecha from 'element-ui/src/utils/date'
import Upload from 'base/upload/upload'
import UEditor from 'base/uEditor/uEditor'
import CurriculumMsg from 'base/promotionMsg/curriculumMsg'
import ShalfSetting from 'base/promotionMsg/shalfSetting'
import Shop from './components/shop'
import UploadFile from 'base/upload/uploadFileResume'
// getCommonAudioInfo 课程详情  getShopGroupList 商品分组
// import { getCommonAudioInfo, getShopGroupList} from 'api/api'
import { getShopGroupList} from 'api/api'
// saveOrUpdateCourseInfo 新增或编辑课程信息
import { saveOrUpdateCourseInfo, getCourseInfo, getCatelist,getTeacherListNopage} from 'api/curriculumApi'
// import {videoMgtCode} from 'api/enumCode'
import {mapGetters, mapActions} from 'vuex'
import {formatCheckView, formatCheckList, formatFileInfo, computeFileSize} from 'common/js/tools'
import ScrollBox from 'base/scrollBox/scrollBox'
import {videoMsg} from 'api/message'
import $ from 'jquery'
import GoodsListDialog from './components/goodsListDialog.vue'
export default {
    name: 'CurriculumEdit',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            // console.log(value)
            if (!value.furl) {
                callback(new Error('请选择课程封面'))
            } else {
                callback()
            }
        }
        let checkOnlineWay = (rule, value, callback) => {
            if (this.item.onlinetype === 2) {
                if (!this.item.onlinetime) {
                    callback(new Error('请选择上架时间'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // let validatesubClass = (rule, value, callback) => {
        //     if (this.item.code) {
        //         callback()
        //     } else {
        //         callback(new Error('请输入课程分类'))
        //     }
        // }
        return {
            videoPng: require('@/common/images/cms/video.png'),
            // onlinetypeList: videoMgtCode.onlinetype,
            // feetypeList: videoMgtCode.feetype,
            caseList:[], //课程分类列表
            // caseListValue:[],
            zjmemtype: [
                {label: '不支持', value: 0},
                {label: 'PLUS卡', value: 1},
                {label: '年卡', value: 2}
            ],
            dmCaseList: [
                {
                    label: '董秘课程',
                    value: 'C01',
                    children: [
                        {
                            label: '三会运作',
                            value: 'C0101'
                        },
                        {
                            label: '投资者关系',
                            value: 'C0102'
                        },
                        {
                            label: '市值管理',
                            value: 'C0103'
                        },
                        {
                            label: '信息披露',
                            value: 'C0104'
                        },
                        {
                            label: '社会责任',
                            value: 'C0105'
                        },
                        {
                            label: '公共关系',
                            value: 'C0106'
                        },
                        {
                            label: '资本运作',
                            value: 'C0107'
                        },
                        {
                            label: '公司治理',
                            value: 'C0108'
                        },
                    ]
                },
                {
                    label: 'IPO课程',
                    value: 'C02',
                    children: [
                        {
                            label: 'IPO财务',
                            value: 'C0201'
                        },
                        {
                            label: 'IPO法律',
                            value: 'C0202'
                        },
                        {
                            label: 'IPO尽调',
                            value: 'C0203'
                        },
                        {
                            label: '股份改造',
                            value: 'C0204'
                        },
                        {
                            label: '机构聘选',
                            value: 'C0205'
                        },
                        {
                            label: '募投可研',
                            value: 'C0206'
                        },
                        {
                            label: '上市路演',
                            value: 'C0207'
                        },
                    ]
                },
                {
                    label: '股权激励',
                    value: 'C03',
                    children: [
                        {
                            label: '股权理论',
                            value: 'C0301'
                        },
                        {
                            label: '激励心法',
                            value: 'C0302'
                        },
                        {
                            label: '股权激励（拟上市）',
                            value: 'C0303'
                        },
                        {
                            label: '股权激励（上市）',
                            value: 'C0304'
                        },
                        {
                            label: '实战技巧',
                            value: 'C0305'
                        },
                    ]
                },
                {
                    label: '投资课程',
                    value: 'C04',
                    children: [
                        {
                            label: '机构投资',
                            value: 'C0401'
                        },
                        {
                            label: '企业融资',
                            value: 'C0402'
                        },
                        {
                            label: '协议安排',
                            value: 'C0403'
                        },
                        {
                            label: '投资尽调',
                            value: 'C0404'
                        },
                        {
                            label: '企业估值',
                            value: 'C0405'
                        },
                        {
                            label: '投后管理',
                            value: 'C0406'
                        },
                        {
                            label: '投资退出',
                            value: 'C0407'
                        }
                    ]
                }
            ],
            teachList:[], //老师列表
            // teachValue:'', //选中的老师
            disabled: false,
            realName: false,
            shopGroupList: [], // 商品分组
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            dateunlockconfig: { // 日期解锁模式配置:按周期,周期类型,章节类型配置
                day: 1,
                date: 1,
                task: 1
            },

            caseListValue:[],
            teachValue:'', //选中的老师
            teacherinfo:[], //选中的老师
            item: {
                code:[],
                teacherinfo:[], //选中的老师
                innerid: this.$route.query.id ? this.$route.query.id : '', // id
                isopennotify: 1, //提醒设置
                isopensmsnotify: 1, // 短信通知
                subject: '', // 课程名称
                content: '', // 课程详情
                description: '', // 课程简介
                coursetype: 1, // 课程类型  1单课 2系列课
                begintime: '', // 课程开始时间
                sectionunlocktype: 1, // 	目录解锁模式--系列课有效:1自有模式 2日期模式
                dateunlockconfig: '', // 日期解锁模式配置:按周期,周期类型,章节类型配置
                dateunlocktime: '', // 解锁时间：HH:mm
                courseinfo: [], // 课程内容信息id，类型json串
                coverpicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }, // 课程封面
                vsource: '1', // 课程来源 1 直接上传 2课程素材
                // mktype: 1, // 票种营销类型(0 无 1限时优惠 3拼团减价 5 助力减价 6分享解锁)
                // discounttype: 2, // 优惠方式 1折扣减免 2定额减免
                // discountvalue: ', // 优惠数值
                // expirehours: '1', // 完成时间-小时
                // datacond: 1, // 使用条件( 1限时：时间，格式yyyy-MM-dd HH:mm 5 助力减价：好友助力人数，数字，大于0 6分享解锁：分享人数，默认为1)
                onlinetype: 1, // 上架方式
                onlinetime: '', // 定时时间
                isplatform: true,
                ispublic: 1,
                isbuyexpire: 0, // 购买有效期
                expiredays: 0, // 有效期时间 开启有效
                isspeedplay: 1, // 倍速播放/快进
                ispreventrecording: 0, // 防录屏跑马灯
                fileuploadtype: '', // 文件上传模式 1选择已有内容 2自定义上传
                customformdataList: [],
                customcatename1: '', // 自定义分类一级名称
                customcatecode1: '', // 自定义分类一级code
                customcatename2: '', // 自定义分类二级名称
                customcatecode2: '', // 自定义分类二级code
                bigmemtype: 0, // 支持董秘会员 默认传0
                zjmemtype: 0, // 支持资鲸会员
                divisionids: [], // 商品分组
                qbcodes: '', // 选择的题库code
                qbnames: '' // 选择的题库名称
            },
            quesList: [],
            customcatecode: [],
            feetype: 1,
            rules: {
                subject: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                    {min: 1, max: 45, message: '长度在1到45个字符', trigger: 'blur'}
                ],
                // subClass: [
                //     { validator: validatesubClass, trigger: 'change' }
                //    // {required: true,type:'Array', message: '请输入课程分类', trigger: 'change'},
                // ],
                coverpicture: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                onlinetype: [
                    {required: true, message: '请选择上架方式', trigger: 'blur'},
                    {validator: checkOnlineWay, trigger: 'blur'}
                ],
                saleprice: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                uprice: [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: '',
                height: ''
            },
            uploadVideoType: {
                catecode: '103',
                datatype: 'VIDEO'
            },
            uploadVideoType2: {
                catecode: '103',
                datatype: 'AUDIO'
            },
            fileRule: {
                btnName: '上传本地视频',
                cls: '',
                accept: 'video/mp4',
                size: 1000,
                btnTypePrimary: false,
                width: '',
                height: '',
                nottype: true
            },
            fileRule2: {
                btnName: '上传本地音频',
                cls: '',
                accept: 'audio/mp3',
                size: 1000,
                btnTypePrimary: false,
                width: '',
                height: '',
                nottype: true
            },
            courseinfoChange: false,
            showCourseForm: false,
            vcaCoursetype: [
                {label: '股权投资基础知识', value: 'VCA001'},
                {label: '股权投资流程', value: 'VCA002'},
                {label: '股权投资决策', value: 'VCA003'},
                {label: '创投人职业发展', value: 'VCA004'},
                {label: '投资风向与趋势', value: 'VCA005'}
            ]
        }
    },
    mounted() {
        // 获取商品分组
        this._getShopGroupList()
        // this._getShopGroupList()
        if (this.item.innerid) {
            this.disabled = true
            this._getView()
        } else {
            if (this.user.isofficalhost) {
                this.item.bigmemtype = 1
            } else {
                this.item.bigmemtype = 0
            }
            // if (this.user.iszjhost) {
            //     this.item.zjmemtype = 1
            // } else {
            //     this.item.zjmemtype = 0
            // }
        }
        if (!this.user.isvcahost) {
            this._getCatelist()
        }
        this._getTeacherList()
    },
    methods: {
        // 打开选择题库弹窗
        handleChoiceQb() {
            this.$refs.goodsListDialog.openDialog(this.quesList.length ? this.quesList.map(item => {return {kmcinnerid: item.kmcinnerid, kmcname: item.kmcname}}) : [])
        },
        handleGetQues(ques) {
            this.quesList = JSON.parse(JSON.stringify(ques))
        },
        handleDeleteQues(index) {
            this.quesList.splice(index, 1)
        },
        _getShopGroupList () {
            getShopGroupList({
                data: {},
                success: data => {
                    this.shopGroupList = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 前往商品分组
        goGoodsGroup() {
            let goPath = window.location.origin + '/shopMgt/goods/goodsGroup'
            window.open(goPath)
        },
        // 增加填写项
        addInput() {
            let obj = {
                colinnerid: '',
                coltype: 1,
                colname: '',
                isnotnull: 1,
                optionsinfo: '',
                placeholder: ''
            }
            this.item.customformdataList.push(obj)
            console.log(this.item.customformdataList)
        },
        // 增加单选项
        addRandio() {
            let obj = {
                colinnerid: '',
                coltype: 6,
                colname: '',
                isnotnull: 1,
                optionsinfo: '',
                optionsArray: [],
                placeholder: ''
            }
            this.item.customformdataList.push(obj)
            console.log(this.item.customformdataList)
        },
        // 增加多选项
        addCheckbox() {
            let obj = {
                colinnerid: '',
                coltype: 7,
                colname: '',
                isnotnull: 1,
                optionsinfo: '',
                optionsArray: [],
                placeholder: ''
            }
            this.item.customformdataList.push(obj)
            console.log(this.item.customformdataList)
        },
        // 增加菜单项
        addSelect() {
            let obj = {
                colinnerid: '',
                coltype: 8,
                colname: '',
                isnotnull: 1,
                optionsinfo: '',
                optionsArray: [],
                placeholder: ''
            }
            this.item.customformdataList.push(obj)
            console.log(this.item.customformdataList)
        },
        // 增加新选项
        addOptions(index) {
            this.item.customformdataList[index].optionsArray.push({optionsName: ''})
            console.log(this.item.customformdataList[index].optionsArray)
        },
        // 删除表单项目
        deleteOptions(index) {
            this.item.customformdataList.splice(index, 1)
            console.log(this.item.customformdataList)
        },
        // 移除选项
        deleteOptionsName(index) {
            console.log(index)
            this.item.customformdataList[index].optionsArray.pop()
            console.log(this.item)
        },
        setFile(file) {
            file.catecode = '103'
            delete file.type
            file.objectname = file.name
            console.log(file)
            this.courseinfoChange = true
            let obj = {
                uploadinfo: file,
                fileuploadtype: 2,
                objectid: '',
                kmctype: 4,
                objectname: file.fname
            }
            this.item.fileuploadtype = 2
            this.item.courseinfo = [obj]
            console.log(this.item.courseinfo)
        },
        setFile2(file) {
            file.catecode = '103'
            delete file.type
            file.objectname = file.name
            console.log(file)
            this.courseinfoChange = true
            let obj = {
                uploadinfo: file,
                fileuploadtype: 2,
                objectid: '',
                kmctype: 6,
                objectname: file.fname
            }
            this.item.fileuploadtype = 2
            this.item.courseinfo = [obj]
            console.log(this.item.courseinfo)
        },
        // 课程分类获取
        _getCatelist(){
            getCatelist({
                success: data => {
                    this.setLoading(false);
                    let arr = [];
                    let arr1 = Array.from(data.data.content);
                    arr1.forEach((item,index)=>{
                        arr.push({
                            name: item.codename,
                            code: item.parentcode,
                            codelist:item.codelist
                        })
                    });
                    this.caseList=arr;
                },
                error: data => {
                    this.setLoading(false);
                    this.$message.error(data.msg)
                }
            })
        },
        // 课程老师获取
        _getTeacherList(){
            getTeacherListNopage({
                success: data => {
                    this.setLoading(false);
                    this.teachList=data.data.content;
                    console.log(data)
                },
                error: data => {
                    this.setLoading(false);
                    this.$message.error(data.msg)
                }
            })
        },
        // 内容列表获取
        setShopList(datalist) {
            console.log(datalist)
            this.item.fileuploadtype = 1
            // delete datalist[0].uprice
            // delete datalist[0].saleprice
            // let obj = {
            //     uploadinfo: datalist[0],
            //     fileuploadtype: 1,
            //     objectid: datalist[0].objectid,
            //     kmctype: datalist[0].kmctype,
            //     objectname: datalist[0].objectname,
            //     furl: datalist[0].furl
            // }
            this.item.courseinfo = datalist
        },
        // 开启选择内容弹出
        openShopDialog() {
            this.$refs.shop.openDialog(this.item.datalist)
        },
        // 跳转商品分组
        goToShopGroup () {
            const _url = window.location.origin
            window.open(`${_url}/shopMgt/goods/goodsGroup`, '_blank')
        },

        // 打开课程素材库选择框
        openVideoScrollBox() {
            this.$refs.videoScrollBox.openDialog()
        },
        // 打开图片素材库选择框（封面）
        openCoverScrollBox() {
            this.$refs.coverScrollBox.openDialog()
        },
        // 设置素材库选择的图片信息（封面）
        setMaterialCoverfile(file) {
            this.item.coverpicture = file;
            this.$refs.coverfile.setImage(this.item.coverpicture.furl)
        },
        // 切换收费/免费
        checkFeetype(val) {
            for (let i in this.item.checkView) {
                this.item.checkView[i].status = false
            }
            // this._getShopGroupList()
        },
        // 设置封面信息（本地）
        setCoverfile(img) {
            this.item.coverpicture = img
        },
        // 获取富文本编辑器内容
        getUEditorContent(content) {
            this.item.content = content
        },
        cancel() {
            this.$confirm(videoMsg.cancelEdit.msg, videoMsg.cancelEdit.title, {
                confirmButtonText: videoMsg.cancelEdit.confirmText,
                cancelButtonText: videoMsg.cancelEdit.cancelText
            }).then(() => {
                this.$router.back()
            }).catch(() => {})
        },
        // 自定义分类改变
        handleCustomcateChange(value) {
            this.item.customcatecode1 = value[0]
            this.item.customcatecode2 = value[1]
            this.dmCaseList.some(item => {
                if (item.value === value[0]) {
                    this.item.customcatename1 = item.label
                    item.children.some(option => {
                        if (option.value === value[1]) {
                            this.item.customcatename2 = option.label
                            return true
                        }
                    })
                    return true
                }
            })
        },
        submitForm() {
            this.$refs.curriculumMsg.$refs.sellWayForm.validate((v) => {
                this.$refs.formName.validate((valid) => {
                    if (valid && v) {
                        this.$confirm(videoMsg.submitEdit.msg, videoMsg.submitEdit.title, {
                            confirmButtonText: videoMsg.submitEdit.confirmText,
                            cancelButtonText: videoMsg.submitEdit.cancelText,
                            closeOnClickModal: false
                        }).then(() => {
                            let item = JSON.parse(JSON.stringify(this.item))
                            if (this.quesList.length) {
                                let qbcodes = []
                                let qbnames = []
                                this.quesList.forEach(item => {
                                    qbcodes.push(item.kmcinnerid)
                                    qbnames.push(item.kmcname)
                                })
                                console.log(qbcodes, qbnames)
                                item.qbcodes = qbcodes.join(',')
                                item.qbnames = qbnames.join(',')
                            } else {
                                item.qbcodes = ''
                                item.qbnames = ''
                            }
                            if (!this.user.isvcahost) {
                                item.code = item.code[item.code.length-1]
                            }
                            if (!this.showCourseForm) {
                                item.customformdataList = []
                            }
                            // this.item.code = this.item.code .join(',')
                            console.log(this.teacherinfo)
                            item.teacherinfo = this.teacherinfo.join(',')
                            let tmpList = formatCheckList(JSON.parse(JSON.stringify(this.$refs.curriculumMsg.item.checkView)))
                            let curriculumMsgItem = JSON.parse(JSON.stringify(this.$refs.curriculumMsg.item))
                            let obj = $.extend(true, {}, Object.assign({}, item, curriculumMsgItem))
                            console.log(obj)
                            obj.checkView = JSON.stringify(tmpList)
                            if (obj.coursetype === 2) {

                                // 判断时间
                                if (!obj.begintime || obj.begintime == '') {
                                    this.$message.error('请选择开始开课时间')
                                    return
                                }
                                obj.begintime = fecha.format(new Date(obj.begintime), 'yyyy-MM-dd HH:mm:ss')
                                if (obj.sectionunlocktype === 2) {
                                    // 判断解锁时间
                                    if (!obj.dateunlocktime || obj.dateunlocktime == '') {

                                        this.$message.error('请选择解锁时间')
                                        return
                                    }
                                    // 判断每日时间
                                    if (this.dateunlockconfig.day == "") {
                                        this.$message.error('开课后时间不能为空')
                                        return
                                    } else if (typeof this.dateunlockconfig.day !== 'number' && this.dateunlockconfig.day % 1 !== 0) {
                                        this.$message.error('开课后时间请输入正确的整数')
                                        return
                                    }
                                }
                            }

                            if (this.item.innerid && this.item.fileuploadtype === 2 && !this.courseinfoChange) {
                                delete obj.courseinfo[0].taskinnerid
                                delete obj.courseinfo[0].fileorgname
                                delete obj.courseinfo[0].viewcount

                                obj.courseinfo[0] = {
                                    uploadinfo: obj.courseinfo[0].uploadinfovo,
                                    objectid: '',
                                    kmctype: 4,
                                    objectname: obj.courseinfo[0].objectname
                                }
                            }
                            if (this.item.fileuploadtype === 1 && obj.courseinfo.length) {
                                delete obj.courseinfo[0].furl
                            }
                            // 课程对象
                            obj.courseinfo = obj.courseinfo.length ? JSON.stringify(obj.courseinfo[0]) : ''
                            if (obj.coursetype == 1) {
                                if (obj.courseinfo == undefined) {
                                    this.$message.error('课程内容不能为空')
                                    return
                                }
                            }
                            // 判断购买有效期时间
                            if(this.item.isbuyexpire==1&&this.item.expiredays<=0){
                                this.$message.error('购买有效期时间必须大于0')
                                return
                            }
                            // console.log('obj.begintime2',obj.begintime)
                            // console.log('obj.dateunlocktime2',obj.dateunlocktime)

                            // console.log('obj.begintime',obj.begintime)
                            // console.log('obj.dateunlocktime',obj.dateunlocktime)

                            // 日期解锁模式配置:按周期,周期类型,章节类型配置

                            obj.dateunlockconfig = this.dateunlockconfig.day+","+this.dateunlockconfig.date+","+this.dateunlockconfig.task

                            obj.coverpicture = formatFileInfo(obj.coverpicture)
                            obj.isplatform = obj.isplatform ? 1 : 0
                            obj.ispublic = obj.ispublic ? 1 : 0
                            obj.divisionids = obj.divisionids.join(',')
                            let form = true
                            // console.log(this.item.customformdataList)
                            if (item.customformdataList.length) {
                                item.customformdataList.some((obj, index) => {
                                    if (obj.coltype === 1) {
                                        if (!obj.colname) {
                                            // this.replaceValue()
                                            this.$message.error('请完善您的表单数据！')
                                            form = false
                                            return true
                                        }
                                    } else {
                                        if (!obj.colname) {
                                            this.$message.error('请完善您的表单数据！')
                                            form = false
                                            return true
                                        }
                                        console.log(obj.optionsArray)
                                        obj.optionsArray.some((item, i) => {
                                            if (!item.optionsName) {
                                                // this.replaceValue()
                                                this.$message.error('请完善您的表单数据！')
                                                form = false
                                                return true
                                            }
                                        })
                                    }
                                    if (!form) {
                                        return true
                                    }
                                })
                                console.log(form)
                                if (form) {
                                    item.customformdataList.some((obj, index) => {
                                        if (obj.coltype !== 1) {
                                            let optionArr=[]
                                            obj.optionsArray.some((item, i) => {
                                                if (item.optionsName.indexOf(',') !== -1) {
                                                    item.optionsName = item.optionsName.replace(',', '，')
                                                }
                                                optionArr.push(item.optionsName)
                                                // obj.arr.some((item, i) => {
                                                // })
                                            })
                                            obj.optionsinfo = optionArr.join(',')
                                        }
                                        obj.colindex = index + 1
                                    })
                                    if (this.$route.query.iscopy == '1') {
                                        this.item.customformdataList.forEach(obj => {
                                            obj.colinnerid = ''
                                        })
                                    }
                                }
                            }
                            delete obj.customformdataList
                            obj.formlist = JSON.stringify(item.customformdataList)
                            if(form) {
                                this._addObject(obj)
                            }

                        }).catch(() => {
                        })
                    } else {
                        return false
                    }
                })
            })
        },
        _addObject(obj) {
            this.setLoading(true)
            saveOrUpdateCourseInfo({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success(videoMsg.submitEdit.successMsg)
                    this.setLoading(false)
                    this.setPage({page: 1, pageSize: 10})

                    // 系列课发布时弹窗提示
                    if (this.item.coursetype == 2 && !this.item.innerid) {

                        this.$confirm('恭喜您，课程发布成功！<br/> 添加内容课程才能生效，快去添加吧。', '提示', {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '前往章节设置',
                            cancelButtonText: '稍后设置',
                        }).then(() => {
                            // 跳转页面
                            this.$router.push({name: 'ChapterSetUp', query: {'innerid': data.data}})
                        }).catch(() => {
                            // 返回上一页
                            this.$router.back()
                        });
                    } else {
                        this.$router.back()
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getCourseInfo({
                data: {
                    hostinnerid: this.user.hostinnerid,
                    innerid: this.item.innerid
                },
                success: data => {
                    this.setLoading(false)
                    // data.data.checkView = formatCheckView(JSON.parse(data.data.checkView), this.$refs.promotionMsg.item.checkView)
                    data.data.customformdataList = []
                    if (data.data.formlist.length) {
                        this.showCourseForm = true
                        data.data.customformdataList = JSON.parse(JSON.stringify(data.data.formlist))
                        data.data.customformdataList.some((obj, index) => {
                            if (obj.coltype !== 1) {
                                let optionsArr = obj.optionsinfo.split(',')
                                obj.optionsArray = []
                                optionsArr.some((item, i) => {
                                    if (item.indexOf('，') !== -1) {
                                        item = item.replace('，', ',')
                                    }
                                    obj.optionsArray.push({optionsName: item})
                                })
                            }
                        })
                    }
                    if (data.data.qbcodes) {
                        let qbcodes = data.data.qbcodes.split(',')
                        let qbnames = data.data.qbnames.split(',')
                        let quesList = []
                        qbcodes.forEach((item, index) => {
                            quesList.push({kmcname: qbnames[index], kmcinnerid: item})
                        })
                        this.quesList = quesList
                    }
                    this.item = data.data
                    if (this.item.customcatecode1 && this.item.customcatecode2) {
                        this.customcatecode = [this.item.customcatecode1, this.item.customcatecode2]
                    }
                    this.$refs.uEditor.init(this.item.content)
                    this.$refs.curriculumMsg.setItem(this.item)
                    this.item.coverpicture = JSON.parse(this.item.coverpicture)
                    this.item.isplatform = this.item.isplatform === 1
                    // this.item.ispublic = this.item.ispublic === 1
                    this.item.ispublic = data.data.ispublic
                    if (!this.user.isvcahost) {
                        if (this.item.code.length > 0) {
                            this.item.code = this.item.code.split(',')
                        }
                    }
                    if (this.item.teacherid.length > 0) {
                        this.teacherinfo = this.item.teacherid.split(',')
                    }

                    console.log(this.item.code)
                    if (this.item.coursetype == 1) {
                        this.item.courseinfo = [JSON.parse(this.item.courseinfo)]
                    } else {
                        this.item.courseinfo = []
                    }

                    // console.log(this.item.courseinfo)

                    let dateunlockconfig = this.item.dateunlockconfig.split(',')

                    this.dateunlockconfig = { // 日期解锁模式配置:按周期,周期类型,章节类型配置
                        day: parseInt(dateunlockconfig[0]),
                        date: parseInt(dateunlockconfig[1]),
                        task: parseInt(dateunlockconfig[2])
                    }
                    this.$refs.coverfile.setImage(this.item.coverpicture.furl)

                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ]),
        changeWay(type) {
            this.feetype = type
        }
    },
    filters: {},
    watch: {
        // 'feetype': {
        //     handler(newFeetype, oldFeetype) {
        //         this._getShopGroupList()
        //     }
        // },
        '$rouer': {

        },
        deep: true,
        immediate: true
    },
    computed: {
        fsize () {
            return function(size) {
                return computeFileSize(size)
            }
        },
        ...mapGetters([
            'loading',
            'user',
            'domain'
        ])
    },
    components: {
        Upload,
        UEditor,
        ScrollBox,
        CurriculumMsg,
        ShalfSetting,
        Shop,
        UploadFile,
        SlickList,
        SlickItem,
        GoodsListDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scpoed>
@import "~common/scss/variable";
@import "~common/scss/mixin";
.curriculumEdit {
    .addLang .el-select,.addLang .el-input{
        width: 500px;
    }
    .module {
        margin-bottom: 20px;
        .module_title {
            // margin-bottom: 0;
            border-left: none;
            padding-bottom: 20px;
            border-bottom: 1px solid #DCDFE6;
            padding-left: 0;
            .title {
                border-left: 2px solid #409EFF;
                padding-left: 5px;
                font-weight: bold;
            }
        }
    }
    .el-input {
       input {
           width: 100%;
           height: 100%;
       }
    }
    .color-999 {
        font-size: 14px;
        color: #999;
    }
    .fledx {
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .courseFlex{
        display: flex;
        align-items: center;
        .el-input{
            width: 100px;
            margin: 0 5px;
        }
    }
    .curriculum-item {
        padding: 12px;
        margin-top: 20px;
        max-width: 810px;
        height:50px;
        box-sizing: border-box;
        background: #F5F7FA;
        p {
            max-width: 660px;
            margin-left: 20px;
            color: #303133;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;

            &:last-child {
                color: #FF4747;
                cursor: pointer;
            }
        }
        img {
            width: 46px;
            height: 26px;
        }
    }
    .setup {
        margin-bottom: 16px;
        .el-input {
            margin: 0 10px;
            width: 84px;
        }
    }
    .model-ml {
        .el-radio {
            margin-top: 8px;
            display: block;

            p {
                color: #999999;
                font-size: 14px;
                margin-top: 15px;
            }
        }
    }

    textarea.el-textarea__inner,
    .el-textarea  {
        width: 811px;
        height: 90px;
    }
    .el-form-item.share {
        display: none;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        margin-left: 15px;
    }

    .upload-image{
        .el-form-item__content{
            @include flexBox(space-between)
        }
    }
    .account-form{
        // margin-top: 20px !important;
        .commodityGroup{
            .el-select{
                width: 368px;
            }
            .el-button{
                min-width: 0;
                margin: 0 10px;
            }
            .groupTips{
                color: #909399;
            }
        }
        .multipleSelect {
            width: 500px !important;
            .el-input {
                min-height: 32px;
                height: auto;
                .el-input__inner {
                    min-height: 32px;
                }
            }
        }
        .relevancyqb {
            .btnTips {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .el-button {
                    margin-right: 10px;
                }
                .tips {
                    font-size: 14px;
                    color: #909399;
                }
            }
            
            .quesItem {
                display: flex;
                padding: 12px;
                max-width: 810px;
                height:50px;
                box-sizing: border-box;
                background: #F5F7FA;
                &:not(:last-of-type) {
                    margin-bottom: 10px;
                }
                .name {
                    font-size: 14px;
                    flex: auto;
                    width: 0;
                    margin-right: 20px;
                    color: #303133;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                }
                .delete {
                    font-size: 14px;
                    color: #FF4747;
                    cursor: pointer;
                }
            }
        }
    }
    .headImage{
        margin-right: 20px;
        .avatar-uploader{
            box-sizing: border-box;
            width: 320px;
            height: 180px;
        }
    }
    .videoName{
        .el-form-item__content{
            width: 810px;
        }
    }
    .el-upload__tip{
        width: 500px;
        color: $tcolor-grey;
        align-self: center;
        flex-grow: 1;
    }
    .uploadBtnBox {
        display: flex;
        align-items: center;
        padding-top: 20px;
        .had {
            width: 124px;
            margin-right: 20px;
        }
    }
    .shopGroup{
        .el-select{
            width: 278px;
        }
        .el-button{
            min-width: 0px;
            margin-right: 10px;
        }
        .refresh{
            margin-left: 12px;
        }
    }
    .courseFrom {
        // background: #fff;
        // padding: 20px;
        // margin-bottom: 24px;
        .module_title {
            display: flex;
            align-items: center;
            .el-switch {
                margin-left: 12px;
            }
        }
        .contentBox {
            input{
                outline: none;
            }
            .optionsBox {
                margin-top: 20px;

                .flex {
                    display: flex;
                    align-items: center;
                }
                .tips {
                    color: #C0C4CC;
                    font-size: 14px;
                    margin-left: 18px;
                }
            }
            .formOptions {
                height: 60px;
                display: flex;
                width: 344px;
                border: 1px solid #D8DCE6;
                // border-radius: 4px;
                &>div {
                    flex: 1;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    line-height: 20px;
                    color: #606266;
                    cursor: pointer;
                    .name {
                        margin-top: 8px;
                    }
                }
                img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
    .btn_box {
        display: flex;
        justify-content: center;
        align-items: center;
        .el-button--primary {
            margin-left: 32px;
        }
    }
}
.tipsP {
    padding: 10px;
    p {
        line-height: 20px;
    }
}
.el-icon-info{
    color: #999;
    padding-left: 10px;
    cursor: pointer;
}
.ques-slickList{
    .slickItem{
        cursor: move;
        box-sizing: border-box;
        margin-bottom:10px;
        width: 464px;
        // border: 1px solid $line;
        // padding: 10px;
    }
}
.formItem {
    width: 464px;
    display: flex;
    justify-content: space-between;
    .el-form-item__label {
        width: 120px !important;
        min-width: 120px;
        padding-right: 64px;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
    .input, .randio, .checkbox, .select {
        position: relative;
        width: 344px;
        border: 1px solid #D8DCE6;
        .optionsName {
            input {
                margin-left: 20px;
            }
        }
        .choiceItem {
            position: relative;
            .delete {
                position: absolute;
                right: 12px;
                bottom: 9px;
                width: 50px;
                height: 20px;
                font-size: 12px;
                text-align: center;
                color: #606266;
                border: 1px solid #C0C4CC;
                line-height: 20px;
                cursor: pointer;
            }
        }
        &>div {
            width: 344px;
            height: 40px;
            line-height: 40px;
            padding: 0 10px;
            box-sizing: border-box;
            border-bottom: 1px solid #EEEEEE;
        }
        .newOptions {
            color: #909399;
            cursor: pointer;
        }
    }
    &:hover {
        .input, .randio, .checkbox, .select {
            border-color: #409EFF;
        }
    }
    img {
        width: 20px;
        height: 20px;
        position: absolute;
        top: -10px;
        right: -10px;
        cursor: pointer;
    }
}
</style>
